import { SELECTEDENTITY } from '../../redux/Types';

const initialState = {
  selectedEntity: null,
};

const generalLedger = (state = initialState, action: any) => {
  switch (action.type) {
    case SELECTEDENTITY:
      return {
        ...state,
        selectedEntity: action.payload,
      };
    default:
      return state;
  }
};

export default generalLedger;
